var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRepairIconRebrand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 21.7666C46.6 21.4666 49.7 21.7666 50.7 21.7666C52.4 21.7666 53.8296 31.5981 55.1296 32.0981C55.9296 32.3981 55.7296 32.2981 57.8296 32.6981C58.7296 32.7981 59.4017 40.1666 58.4017 44.5666C56.1017 44.5666 52.7 44.6666 50.5 44.6666",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2998 44.7666C39.5998 44.7666 35.7998 44.8666 31.6998 44.8666C26.9998 44.8666 23.3998 45.1666 18.6998 45.0666C18.2998 45.0666 17.7998 45.0666 17.2998 45.0666",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40861 45.1152C3.00861 45.0152 2.59982 44.4667 2.99982 41.2667C3.09982 40.7667 3.09932 39.7092 4.19932 39.7092",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.739 48.1666C16.539 46.3666 15.839 43.2666 12.639 43.3666C9.239 43.3666 8.839 47.0666 9.939 48.5666C11.739 50.6666 14.939 50.0666 15.739 48.1666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9005 44.8666C43.4005 46.0666 43.3005 47.5666 44.5005 48.4666C46.0005 49.7666 48.2005 49.8666 49.5005 48.2666C50.7005 46.6666 50.7005 44.6666 49.2005 43.4666C47.4005 42.0666 44.7005 42.7666 43.9005 44.8666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6486 45.0869C37.795 45.3253 37.9921 45.545 38.2486 45.7373C39.7486 47.0373 41.9486 47.1373 43.2486 45.5373C43.3589 45.3903 43.459 45.2398 43.5488 45.0869",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5934 45.0869C19.5036 45.2398 19.4035 45.3903 19.2932 45.5373C18.5603 46.4393 17.5414 46.801 16.5231 46.712",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2002 24.5667H48.7626C48.1865 24.5667 47.7296 25.0521 47.7644 25.6271L48.1165 31.4431C48.1484 31.9709 48.5858 32.3827 49.1146 32.3827H56.3388",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2998 44.7666C43.3998 43.9666 45.0998 42.7666 47.0998 42.7666",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86584 45.1666C10.1658 43.8666 11.1658 43.2666 13.0658 43.2666",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0886 45.0871H42.848M9.5044 45.0871H4.37673C4.25317 33.9679 4.44022 27.4832 5.19487 16.8648C5.2674 15.8444 6.1047 15.042 7.12724 15.0109C20.4873 14.6034 28.7222 14.5911 42.0656 15.0075C43.1115 15.0402 43.9585 15.8776 43.9989 16.9231C44.3993 27.2761 44.3132 33.6718 43.9566 44.1318",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4992 32.5325L27.4203 25.7229C27.2511 25.3178 27.1577 24.8731 27.1577 24.4066C27.1577 22.519 28.6879 20.9887 30.5756 20.9887C30.6657 20.9887 30.7521 20.9893 30.836 20.9916C31.1798 21.0014 31.6862 21.4633 31.443 21.7065L29.5486 23.5391C29.309 23.7787 29.309 24.1671 29.5486 24.4066L30.5755 25.4025C30.8151 25.642 31.2035 25.642 31.443 25.4025L33.3402 23.5392C33.5819 23.2974 33.9775 23.765 33.9894 24.1066C33.9928 24.2028 33.9934 24.3022 33.9934 24.4066C33.9934 26.2943 32.4632 27.8245 30.5756 27.8245C30.1004 27.8245 29.6479 27.7276 29.2368 27.5524L22.2988 34.3696",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5005 32.535C20.0894 32.3598 19.6369 32.2629 19.1618 32.2629C17.2741 32.2629 15.7439 33.7931 15.7439 35.6808C15.7439 35.7852 15.7445 35.8846 15.7479 35.9808C15.7598 36.3224 16.1554 36.79 16.3971 36.5482L18.2943 34.6849C18.5338 34.4454 18.9222 34.4454 19.1618 34.6849L20.1887 35.6808C20.4283 35.9203 20.4283 36.3087 20.1887 36.5483L18.2943 38.3809C18.0511 38.6241 18.5575 39.086 18.9013 39.0958C18.9852 39.0981 19.0716 39.0987 19.1618 39.0987C21.0494 39.0987 22.5796 37.5684 22.5796 35.6808C22.5796 35.2143 22.4862 34.7696 22.317 34.3645",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 31.5006C28.3388 31.236 28.7679 31.236 29.0325 31.5006C29.2046 31.6728 29.2169 31.869 29.213 32.1352C29.209 32.4015 29.5404 32.6893 29.8201 32.7424C30.157 32.7938 30.481 32.9492 30.7404 33.2086L32.9959 35.5512C33.6428 36.1981 33.6428 37.2469 32.9959 37.8939C32.349 38.5408 31.3002 38.5408 30.6533 37.8939L28.3978 35.5512C28.1265 35.2799 27.969 34.9379 27.9252 34.5846C27.8937 34.3111 27.6406 34.0654 27.3887 34.048C27.1368 34.0307 26.8703 34.0237 26.6898 33.8433C26.4252 33.5786 26.4252 33.1496 26.6898 32.885L28.0742 31.5006Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0692 22.8591L23.9708 28.7011M27.2664 32.0038L26.2733 31.0108",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 23.1123L18.3757 22.1677L19.7003 23.1123L20.2793 24.8637L20.1199 25.0572L18.3757 24.4369L17.34 23.1123Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4255 40.8704C59.6682 42.402 59.6005 43.2206 59.0517 44.5966",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRepairIconRebrand);
export default __webpack_public_path__ + "static/media/new-repair-icon-rebrand.aaf31f782ce89b12e238d9c3c72fb13d.svg";
export { ForwardRef as ReactComponent };